// IFC Course Data - Chapter information, videos, and structure
export const IFC_CHAPTERS = [
  {
    id: 1,
    title: "The Role of the Mutual Fund Sales Representative",
    video: "https://youtu.be/3Uhzil9im9s",
    podcast: "https://youtu.be/kE7ze6vKy00",
    description: "Learn about the responsibilities, duties, and ethical standards required of mutual fund sales representatives in Canada.",
    topics: ["Role and responsibilities", "Professional conduct", "Client relationships", "Regulatory requirements"],
  },
  {
    id: 2,
    title: "Overview of the Canadian Financial Marketplace",
    video: "https://youtu.be/bTtqEYh76jA",
    podcast: "https://youtu.be/0jf53LCeZ6c",
    description: "Understand the structure of Canadian financial markets, key institutions, and regulatory bodies.",
    topics: ["Financial institutions", "Market structure", "Regulatory bodies", "Investment products overview"],
  },
  {
    id: 3,
    title: "Overview of Economics",
    videos: [
      { title: "Part 1", url: "https://youtu.be/KK-GKWODt6o" },
      { title: "Part 2", url: "https://youtu.be/LH9Nz-qOO8w" },
    ],
    podcast: "https://youtu.be/RFcQvAKcMe8",
    description: "Master economic concepts essential for investment decision-making and market analysis.",
    topics: ["Economic indicators", "Business cycles", "Monetary policy", "Fiscal policy"],
  },
  {
    id: 4,
    title: "Getting to Know the Client",
    video: "https://youtu.be/_m0qtRtF6TQ",
    podcast: "https://youtu.be/6HrU6HuNvyg",
    description: "Learn the Know Your Client (KYC) process and suitability requirements.",
    topics: ["KYC requirements", "Risk assessment", "Investment objectives", "Suitability analysis"],
  },
  {
    id: 5,
    title: "Behavioural Finance",
    video: "https://youtu.be/o-xlyBPtaGk",
    podcast: "https://youtu.be/Nk7Do4eNArc",
    description: "Understand psychological biases that affect investment decisions.",
    topics: ["Cognitive biases", "Emotional decision-making", "Investor psychology", "Behavioural patterns"],
  },
  {
    id: 6,
    title: "Tax and Retirement Planning",
    video: "https://youtu.be/WC37bQpNgHg",
    podcast: "https://youtu.be/AK_8c3ltr2g",
    description: "Learn tax-efficient investment strategies and retirement planning fundamentals.",
    topics: ["RRSP", "TFSA", "Tax planning", "Retirement income strategies"],
  },
  {
    id: 7,
    title: "Types of Investment Products and How They Are Traded",
    video: "https://youtu.be/6BEZkEga2kY",
    podcast: "https://youtu.be/XZ-qgT5Nt6I",
    description: "Explore various investment products and trading mechanisms.",
    topics: ["Equities", "Fixed income", "Derivatives", "Trading mechanisms"],
  },
  {
    id: 8,
    title: "Constructing Investment Portfolios",
    video: "https://youtu.be/zGCZesnLEzY",
    podcast: "https://youtu.be/STDU8HX17uA",
    description: "Learn portfolio construction principles and asset allocation strategies.",
    topics: ["Asset allocation", "Diversification", "Risk management", "Portfolio optimization"],
  },
  {
    id: 9,
    title: "Understanding Financial Statements",
    video: "https://youtu.be/GvuzmHovMLw",
    podcast: "https://youtu.be/o-ZkXBNU-ds",
    description: "Analyze financial statements for investment decision-making.",
    topics: ["Balance sheet", "Income statement", "Cash flow", "Financial ratios"],
  },
  {
    id: 10,
    title: "The Modern Mutual Fund",
    video: "https://youtu.be/Fsr1f5oY84Q",
    podcast: null,
    description: "Understand mutual fund structures, operations, and regulations.",
    topics: ["Fund structure", "NAV calculation", "Fund operations", "Regulatory framework"],
  },
  {
    id: 11,
    title: "Conservative Mutual Fund Products",
    video: "https://youtu.be/3g06AVImsH8",
    podcast: "https://youtu.be/u121iWsEA-o",
    description: "Explore money market funds, bond funds, and other conservative options.",
    topics: ["Money market funds", "Bond funds", "Income funds", "Capital preservation"],
  },
  {
    id: 12,
    title: "Riskier Mutual Fund Products",
    video: "https://youtu.be/lfWxESkHnGM",
    podcast: "https://youtu.be/4y5ZMdL3vJc",
    description: "Learn about equity funds, sector funds, and higher-risk investment options.",
    topics: ["Equity funds", "Sector funds", "Growth funds", "Aggressive strategies"],
  },
  {
    id: 13,
    title: "Alternative Managed Products",
    video: "https://youtu.be/V9dLxsV6sSs",
    podcast: null,
    description: "Understand hedge funds, private equity, and alternative investments.",
    topics: ["Hedge funds", "Private equity", "Real estate funds", "Alternative strategies"],
  },
  {
    id: 14,
    title: "Understanding Mutual Fund Performance",
    video: "https://youtu.be/BW7O2f_7DzM",
    podcast: null,
    description: "Analyze and evaluate mutual fund performance metrics.",
    topics: ["Performance measurement", "Benchmarking", "Risk-adjusted returns", "Attribution analysis"],
  },
  {
    id: 15,
    title: "Selecting a Mutual Fund",
    video: "https://youtu.be/x4EcgzSUoz4",
    podcast: null,
    description: "Learn the criteria and process for selecting appropriate mutual funds.",
    topics: ["Fund selection criteria", "Due diligence", "Comparative analysis", "Suitability matching"],
  },
  {
    id: 16,
    title: "Mutual Fund Fees and Services",
    video: "https://youtu.be/KkFwnlPPhXI",
    podcast: null,
    description: "Understand fee structures, sales charges, and service options.",
    topics: ["MER", "Sales charges", "Trailing commissions", "Fee disclosure"],
  },
  {
    id: 17,
    title: "Mutual Fund Dealer Regulation",
    video: "https://youtu.be/lkWd-YYLkm0",
    podcast: null,
    description: "Learn about regulatory requirements and compliance obligations.",
    topics: ["MFDA regulations", "Compliance requirements", "Dealer obligations", "Supervisory procedures"],
  },
  {
    id: 18,
    title: "Applying Ethical Standards to What You Have Learned",
    video: "https://youtu.be/uYCtQPsRpIg",
    podcast: null,
    description: "Apply ethical principles and professional standards in practice.",
    topics: ["Code of ethics", "Professional standards", "Conflict of interest", "Best practices"],
  },
];

export const NUMERICAL_PRACTICE = {
  id: "numerical",
  title: "Numerical Practice",
  description: "Master the calculations and numerical problems commonly tested on the IFC exam.",
  videos: [
    { title: "Part 1", url: "https://youtu.be/X6MlEz7AABY" },
    { title: "Part 2", url: "https://youtu.be/Lp-dp_lJ3Mc" },
    { title: "Part 3", url: "https://youtu.be/7GRIws4q7Qo" },
    { title: "Part 4", url: "https://youtu.be/oCGGjMszSqY" },
  ],
  topics: ["NAV calculations", "Return calculations", "Fee calculations", "Tax computations"],
};

export const MOCK_EXAMS = [
  { id: 1, title: "Mock Exam 1", questions: 100, duration: "3 hours", key: "mock1" },
  { id: 2, title: "Mock Exam 2", questions: 100, duration: "3 hours", key: "mock2" },
  { id: 3, title: "Mock Exam 3", questions: 100, duration: "3 hours", key: "mock3" },
  { id: 4, title: "Case Studies Exam", questions: 50, duration: "2 hours", key: "mock4" },
  { id: 5, title: "Numericals Exam", questions: 50, duration: "2 hours", key: "mock5" },
  { id: 6, title: "Final Mock Exam", questions: 100, duration: "3 hours", key: "mock6" },
];

export const IFC_EXAM_INFO = {
  weighting: [
    { topic: "Introduction to the Mutual Funds Marketplace", weight: "13%" },
    { topic: "The Know Your Client Communication Process", weight: "19%" },
    { topic: "Understanding Investment Products and Portfolios", weight: "18%" },
    { topic: "The Modern Mutual Fund", weight: "5%" },
    { topic: "Analysis of Mutual Funds", weight: "10%" },
    { topic: "Understanding Alternative Managed Products", weight: "3%" },
    { topic: "Evaluating and Selecting Mutual Funds", weight: "16%" },
    { topic: "Ethics, Compliance, and Mutual Fund Regulation", weight: "16%" },
  ],
  structure: [
    { label: "Number of Exams", value: "1" },
    { label: "Exam Format", value: "Proctored (remote or in-person)" },
    { label: "Exam Duration", value: "3 hours" },
    { label: "Question Format", value: "Multiple Choice" },
    { label: "Questions Per Exam", value: "100" },
    { label: "Attempts Allowed", value: "3" },
    { label: "Passing Grade", value: "60%" },
    { label: "Hours of Study", value: "90 - 140 Hours" },
    { label: "Enrolment Period", value: "1 Year" },
  ],
  ceCredits: [
    { accreditation: "IFSE SFPA", credits: "15" },
    { accreditation: "IFSE SC", credits: "5" },
    { accreditation: "ICM Life Insurance", credits: "10" },
    { accreditation: "ICBC Life Insurance", credits: "30" },
    { accreditation: "AIC Life Insurance", credits: "20" },
  ],
};
